import type { LearnPracticalContent } from "../practicalContent.js";

export const firstAidContent: LearnPracticalContent = {
  th: {
    notice: [
      "เลือดออกมาก หายใจไม่ได้ ไม่ตอบสนอง หรืออาการทรุดเร็ว เป็นเหตุที่ต้องขอความช่วยเหลือเร่งด่วน",
      "การช่วยเด็ก ทารก หญิงตั้งครรภ์ และผู้หมดสติอาจใช้วิธีต่างกัน",
      "ก่อนช่วย ให้ดูอันตรายรอบตัว การตอบสนอง การหายใจ และเลือดออกที่คุกคามชีวิต",
      "วิดีโอสั้นและโพสต์ออนไลน์ไม่ทดแทนการเรียนกับผู้สอน โดยเฉพาะทักษะ CPR การใช้ AED และการช่วยเด็กหรือทารก",
    ],
    prepare: [
      "เรียนปฐมพยาบาลและ CPR จากหลักสูตรที่มีผู้สอน",
      "เก็บชุดปฐมพยาบาลและเบอร์ติดต่อสำคัญในจุดที่หาได้ง่าย",
      "เตรียมถุงมือหรืออุปกรณ์กั้นของเหลว และรู้ตำแหน่ง AED ในสถานที่ที่ไปเป็นประจำ",
      "บอกคนในบ้านว่าอุปกรณ์อยู่ที่ใด และตรวจวันหมดอายุของของใช้ในชุดปฐมพยาบาลตามคำแนะนำของผู้ผลิต",
    ],
    during: [
      "ตรวจว่าบริเวณปลอดภัยสำหรับผู้ช่วยก่อน แล้วเรียกความช่วยเหลือ",
      "สำหรับเลือดออกภายนอก ใช้ผ้าสะอาดกดตรงแผลอย่างมั่นคงระหว่างรอความช่วยเหลือ",
      "เฝ้าดูการหายใจและการตอบสนอง อยู่กับผู้บาดเจ็บ และทำตามคำแนะนำของผู้รับแจ้งเหตุ",
      "ให้ข้อมูลที่รู้จริง เช่น จุดเกิดเหตุ จำนวนผู้บาดเจ็บ และอันตรายรอบตัวแก่ผู้รับแจ้งเหตุ โดยไม่วินิจฉัยโรคหรืออาการแทนผู้เชี่ยวชาญ",
    ],
    avoid: [
      "อย่าทำหัตถการที่ไม่ได้รับการฝึก เช่น ใช้สายรัดหรือเอาสิ่งที่ฝังออก",
      "อย่าใช้วิธีช่วยผู้สำลักแบบเดียวกันกับผู้ใหญ่ เด็ก และทารก—เรียนรู้วิธีจากผู้ฝึกสอน",
      "อย่าให้อาหาร น้ำ หรือยาแก่ผู้ไม่รู้สึกตัว และอย่าเคลื่อนย้ายเมื่อสงสัยบาดเจ็บศีรษะ คอ หรือหลัง เว้นแต่พื้นที่ไม่ปลอดภัย",
      "อย่าทิ้งผู้บาดเจ็บไว้ลำพังเพื่อไปค้นหาอุปกรณ์ หากมีคนอื่นสามารถโทรหรือไปเรียกความช่วยเหลือได้",
    ],
    help: [
      "โทรขอความช่วยเหลือฉุกเฉินเมื่อเลือดออกมาก หายใจไม่ได้ ไม่ตอบสนอง หรือไม่แน่ใจว่าปลอดภัย",
      "ทำตามคำแนะนำของผู้รับแจ้งเหตุจนทีมช่วยเหลือมาถึง",
      "ขอความช่วยเหลือเร่งด่วนเมื่ออาการแย่ลง เจ็บหน้าอก ชัก สับสนมาก หรือมีปฏิกิริยาแพ้รุนแรง",
      "หลังเหตุ ให้ผู้บาดเจ็บรับการประเมินเพิ่มเติมตามคำแนะนำ โดยเฉพาะเมื่อมีการกระแทกศีรษะ อาการกลับมา หรือมีข้อกังวลใหม่",
    ],
    example:
      "เห็นคนมีเลือดออกมากหลังเกิดอุบัติเหตุ: ตรวจว่าบริเวณปลอดภัย เรียกความช่วยเหลือ และใช้ผ้าสะอาดกดตรงแผลระหว่างรอทีมช่วยเหลือ โดยไม่ดึงสิ่งที่ฝังอยู่ในแผล",
    situations: [
      {
        title: "ในที่ทำงาน",
        text: "ดูความปลอดภัยก่อน ให้คนหนึ่งโทรขอความช่วยเหลือ ขณะที่อีกคนอยู่กับผู้บาดเจ็บและทำเฉพาะสิ่งที่ผ่านการฝึก",
      },
      {
        title: "อยู่กับเด็ก",
        text: "เรียกผู้ใหญ่หรือผู้รับผิดชอบเพิ่ม อย่าใช้วิธีช่วยผู้ใหญ่กับเด็กหรือทารกโดยไม่เคยเรียนจากผู้สอน",
      },
      {
        title: "ระหว่างเดินทาง",
        text: "อย่าหยุดช่วยในช่องจราจรหรือจุดเสี่ยง ให้ย้ายตัวเองไปจุดปลอดภัยก่อนและบอกตำแหน่งกับผู้รับแจ้งเหตุ",
      },
    ],
    checklist: [
      "ดูความปลอดภัยของผู้ช่วย",
      "ดูการตอบสนองและการหายใจ",
      "เรียกความช่วยเหลือ",
      "กดตรงแผลเมื่อเลือดออกมาก",
      "เรียนทักษะจากผู้ฝึกสอนล่วงหน้า",
      "บอกตำแหน่งและอันตรายจริงเมื่อโทรขอช่วยเหลือ",
      "ตรวจชุดปฐมพยาบาลเป็นระยะ",
    ],
  },
  en: {
    notice: [
      "Severe bleeding, inability to breathe, unresponsiveness, or rapid deterioration requires urgent help.",
      "Care can differ for adults, children, infants, pregnancy, and an unresponsive person.",
      "Before helping, check for danger, responsiveness, breathing, and life-threatening bleeding.",
      "Short videos and online posts do not replace instructor-led learning, especially for CPR, AED use, and aid for children or infants.",
    ],
    prepare: [
      "Take an instructor-led first-aid and CPR course.",
      "Keep a first-aid kit and important contact numbers easy to find.",
      "Keep gloves or another fluid barrier available and learn where AEDs are located in places you use often.",
      "Tell household members where supplies are kept and check first-aid-kit item expiry dates as the manufacturer directs.",
    ],
    during: [
      "Check that the area is safe for the helper, then call for help.",
      "For external bleeding, use a clean cloth to apply firm direct pressure while help is coming.",
      "Monitor breathing and responsiveness, stay with the person, and follow the emergency call-taker's instructions.",
      "Give the call-taker facts such as location, number of injured people, and surrounding dangers without diagnosing the illness or injury yourself.",
    ],
    avoid: [
      "Do not perform untrained procedures such as tourniquet use or removing embedded objects.",
      "Do not use the same choking technique for adults, children, and infants—learn the differences from a trainer.",
      "Do not give food, drink, or medicine to an unresponsive person, and avoid moving a possible head, neck, or back injury unless the scene is unsafe.",
      "Do not leave an injured person alone to look for equipment if another person can call or seek help.",
    ],
    help: [
      "Call emergency help for severe bleeding, inability to breathe, unresponsiveness, or uncertainty about safety.",
      "Follow the emergency call-taker's instructions until responders arrive.",
      "Seek urgent help for worsening symptoms, chest pain, seizure, severe confusion, or a severe allergic reaction.",
      "After the incident, arrange further assessment as advised, especially after a head impact, returning symptoms, or a new concern.",
    ],
    example:
      "After an accident, someone is bleeding heavily: make sure the scene is safe, call for help, and press a clean cloth directly on the wound while waiting. Do not remove an embedded object.",
    situations: [
      {
        title: "Workplace",
        text: "Check safety first. Have one person call for help while another stays with the injured person and does only skills they have been trained to use.",
      },
      {
        title: "With a child",
        text: "Call another responsible adult. Do not use an adult technique for a child or infant unless you learned the difference from an instructor.",
      },
      {
        title: "Travel",
        text: "Do not stop to help in a traffic lane or other hazard. Move yourself to safety first and give the call-taker the location.",
      },
    ],
    checklist: [
      "Check scene safety",
      "Check response and breathing",
      "Call for help",
      "Use direct pressure for severe bleeding",
      "Learn hands-on skills from an instructor",
      "State the actual location and hazards when calling",
      "Check the first-aid kit regularly",
    ],
  },
};
